var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-main-listado-videos-contrato"}},[_c('desktop',{attrs:{"listadoVideos":_vm.listadoVideos,"soloLectura":_vm.soloLectura}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }